import(/* webpackMode: "eager" */ "/codebuild/output/src3094709904/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/chat/page.tsx");
